<script>
export default {
  name: "AccessDenied",

  data: () => ({
    contractLink: "",
    linkDisabled: false,
    pollingInterval: null,
    docusignEvent: null
  }),

  computed: {
    code() {
      return this.$route.query.code;
    }
  },

  methods: {
    toMain() {
      if (this.$store.getters["authentication/hasAccessToken"]) {
        this.$router.push("/");
      } else {
        this.$router.push("/auth/login");
      }
    },
    async generateSigningLink() {
      try {
        this.linkDisabled = true;
        const response = await this.$API.docusign().getSigningLink();
        console.log(response);
        //
        if (response.url) {
          window.location.href = response.url;
        } else {
          await this.$store.dispatch(
            "alert/showError",
            "Unable to generate signing link"
          );
        }
      } catch (error) {
        let errorMessage = "Failed to generate signing link";

        if (error.response?.error) {
          errorMessage = error.response.error;
        }

        await this.$store.dispatch("alert/showError", errorMessage);
      } finally {
        this.linkDisabled = false;
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    async checkSigningStatus() {
      try {
        const response = await this.$API.docusign().getStatus();
        if (response.status === "signed") {
          window.location.href = "/profile/dashboard";
        }
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },

    startPolling() {
      // Clear any existing interval first
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }

      // Start polling every 5 seconds
      this.pollingInterval = setInterval(() => {
        this.checkSigningStatus();
      }, 5000); // 5000 milliseconds = 5 seconds

      // Also check immediately without waiting for first interval
      this.checkSigningStatus();
    }
  },
  mounted() {
    if (this.code === "docusign") this.startPolling();
  },

  beforeDestroy() {
    // Clean up the interval when a component is destroyed
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }
};
</script>

<template>
  <div
    class="error-container text-center d-flex justify-center fill-height align-center"
  >
    <div>
      <div class="pl-3 mt-15">
        <div class="text-md-h6 text-sm-body-1 message-container">
          <div v-if="code === 'docusign'">
            <span>
              Please use the button bellow to sign the contract, otherwise
              you'll not be able to use the dashboard.
            </span>
            <br />
            <span class="error--text">
              If you already signed the contract please ignore this button
            </span>
            <br />
            <v-btn
              class="font-weight-bold my-2"
              color="primary"
              text
              @click="generateSigningLink"
              :disabled="linkDisabled"
            >
              Sign the contract
            </v-btn>
          </div>
          <div v-else-if="code === 'authorize'">
            <span>
              It takes up to 24 hours to charge the payment After charge, the
              account will be active.
            </span>
          </div>
          <div class="" v-else>
            Whooops, it seems like your account has been blocked!
          </div>
          <span>
            If you have any questions, please contact us at
            <a href="mailto:customersupport@scoreboostsolution.com">
              customersupport@scoreboostsolution.com
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.message-container {
  max-width: 500px;
  padding: 0 20px;
}
</style>
